import Button from '@pelckmans/elementis/components/button';
import ButtonGroup from '@pelckmans/elementis/components/button-group';
import GeneralNotice from '@pelckmans/elementis/components/general-notice';
import { ReactNode } from 'react';
import AppStyles from '../../AppStyles';
import ContentBody from '../../layout/content/ContentBody';
import { buildGroupProps } from '../../utils/elementisUtils';

export type Props = {
  headerText: string;
  message?: ReactNode;
  link?: {
    to: string;
    text: string;
  };
};

export default function ErrorPage({ headerText, link, message }: Props) {
  const { REACT_APP_P_STUDIO_GROUP } = process.env;

  return (
    <AppStyles>
      <div className="page error-page">
        <div className="page-content">
          <div className="main-layout">
            <div className="main-layout-container">
              <div className="content-layout">
                <main>
                  <div className="margin-wrapper">
                    <div className="content-header" />
                    <ContentBody>
                      <GeneralNotice
                        data-testid="error-screen"
                        logoProps={{
                          variant: REACT_APP_P_STUDIO_GROUP,
                          'aria-label': 'logo',
                          size: REACT_APP_P_STUDIO_GROUP === 'BAO' ? 'md' : 'lg',
                        }}
                        text={headerText}
                        subText={message}
                        action={
                          link && (
                            <ButtonGroup
                              {...buildGroupProps(
                                <Button prominence="neutral" as="link" href={link.to} reloadDocument>
                                  {link.text}
                                </Button>,
                              )}
                            />
                          )
                        }
                      />
                    </ContentBody>
                  </div>
                </main>
              </div>
            </div>
          </div>
        </div>
      </div>
    </AppStyles>
  );
}
